(() => {
  if (window.__lmpAvailabilityOrderLoaded) return;
  window.__lmpAvailabilityOrderLoaded = true;

  const blockUnavailable = (event) => {
    const button = event.target?.closest?.('button[disabled], .js-add-to-cart[aria-disabled="true"]');
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  };

  document.addEventListener('click', blockUnavailable, true);

  const containerSelector = [
    '.collection__items',
    '.e-featured-products__track',
    '.product-grid',
    '.product-list',
    '.product-slider__slides'
  ].join(',');

  const unavailable = (item) => {
    const card = item.matches('.product-card, .e-product-card')
      ? item
      : item.querySelector('.product-card, .e-product-card');

    return Boolean(card && (
      card.dataset.lmpAvailable === 'false' ||
      card.querySelector('.product-card__label--sold-out, .e-product-card__badge--sold-out, .js-add-to-cart:disabled')
    ));
  };

  const reorder = (container) => {
    if (!container?.isConnected) return;

    const items = Array.from(container.children).filter((item) =>
      item.matches?.('.product-card, .e-product-card') ||
      item.querySelector?.('.product-card, .e-product-card')
    );

    if (items.length < 2) return;

    const states = items.map((item) => ({ item, isUnavailable: unavailable(item) }));
    const ordered = states
      .filter(({ isUnavailable }) => !isUnavailable)
      .concat(states.filter(({ isUnavailable }) => isUnavailable))
      .map(({ item }) => item);

    if (ordered.every((item, index) => item === items[index])) return;
    container.append(...ordered);
  };

  const pending = new Set();
  let frame = 0;

  const flush = () => {
    frame = 0;
    const containers = Array.from(pending);
    pending.clear();
    containers.forEach(reorder);
  };

  const queue = (container) => {
    if (!container?.matches?.(containerSelector)) return;
    pending.add(container);
    if (!frame) frame = window.requestAnimationFrame(flush);
  };

  const observedContainers = new WeakSet();

  const observeContainer = (container) => {
    if (!container?.matches?.(containerSelector)) return;
    queue(container);

    if (observedContainers.has(container)) return;
    observedContainers.add(container);

    const observer = new MutationObserver((mutations) => {
      if (mutations.some((mutation) => mutation.addedNodes.length || mutation.removedNodes.length)) {
        queue(container);
      }
    });

    /* Only direct product additions/removals matter. Judge.me and other app
       mutations inside cards no longer wake this observer. */
    observer.observe(container, { childList: true });
  };

  const scan = (scope) => {
    if (!(scope instanceof Element) && scope !== document) return;
    if (scope.matches?.(containerSelector)) observeContainer(scope);
    scope.querySelectorAll?.(containerSelector).forEach(observeContainer);
  };

  const start = () => {
    scan(document);

    /* AJAX filters can replace complete product grids on collection/search
       pages. The homepage has static grids, so do not keep a subtree observer
       running there. */
    const dynamicGridPage = document.body.classList.contains('template-collection') ||
      document.body.classList.contains('template-search');

    if (!dynamicGridPage) return;

    const discoveryRoot = document.querySelector('#MainContent') || document.querySelector('main') || document.body;
    const discoveryObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          if (node.matches(containerSelector)) observeContainer(node);
          node.querySelectorAll?.(containerSelector).forEach(observeContainer);
        });
      });
    });

    discoveryObserver.observe(discoveryRoot, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
